const scoreColor = (score) => {
  if (score >= 0.8) return { bg: "#C8E6C9", text: "#0A0A0A" };
  if (score >= 0.6) return { bg: "#FFCC00", text: "#0A0A0A" };
  return { bg: "#F8F9FA", text: "#0A0A0A" };
};

const MatchScoreBadge = ({ score, size = "md" }) => {
  const { bg, text } = scoreColor(score);
  const px = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";
  return (
    <div
      className={`inline-flex items-center gap-1 brutal-border rounded-full font-mono font-bold ${px}`}
      style={{ background: bg, color: text }}
      data-testid="match-score-badge"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#0A0A0A]" />
      {(score * 100).toFixed(0)}% match
    </div>
  );
};

export default MatchScoreBadge;
